import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const Content = styled.div`
  overflow: auto;
  max-height: 70vh;
  margin-bottom: 20px;
  width: 90vw;
  ${media.mediumUp`
        margin-bottom: 30px;
        width: 50vw;
    `}
`;

export const Error = styled.p`
  color: ${p => p.theme.colors.negative700};
`;
